import { FC } from 'react';

import classes from './Address.module.scss';

const Address: FC = () => {
  return (
    <div className={classes.address}>
      <div className={classes.item}>
        <h3>오시는 길</h3>
        <p>
          아펠가모 공덕 마리에홀
          <br />
          서울 마포구 마포대로 92
          <br />
          효성해링턴스퀘어 B동 7층
          <br />
          <a href="tel:02-2197-0230">02-2197-0230</a>
        </p>
      </div>

      <div className={classes.item}>
        <h3>주차</h3>
        <p>공덕역 10번 출구 옆 효성해링턴 스퀘어 B동</p>
      </div>

      <div className={classes.item}>
        <h3>지하철</h3>
        <p className={classes.sub}>
          공덕역 10번 출구(<b style={{ color: '#6b9a7e' }}>●</b>경의 중앙선,{' '}
          <b style={{ color: '#7da5cc' }}>●</b>공항철도)
        </p>
        <p className={classes.detail}>
          출구에서 유턴 후 전방 우측
          <br />
          효성해링턴 스퀘어 B동 7층 (도보 30초)
        </p>
        <p className={classes.sub}>
          공덕역 7번 출구(<b style={{ color: '#5a468d' }}>●</b>5호선,{' '}
          <b style={{ color: '#a5542e' }}>●</b>6호선)
        </p>
        <p className={classes.detail}>
          출구 우측 '웰스 타워'통로 직진 후<br />
          효성해링턴 스퀘어 7층 (도보 2분)
        </p>
      </div>

      <div className={classes.item}>
        <h3>버스</h3>
        <p>
          <b style={{ color: '#3762ad' }}>간선</b> 160, 260, 600
        </p>
        <p>
          <b style={{ color: '#3eb042' }}>지선</b> 7013A, 7013B, 7611
        </p>
        <p>
          <b style={{ color: '#8bbe40' }}>마을</b> 마포01, 마포02, 마포10
        </p>
      </div>
    </div>
  );
};

export default Address;
